import { useHandleRequestErrors } from 'utils/hooks';
import { ResponseError } from 'services/api/base';
import { useGetWBSequentialMapsOptionsQuery } from 'services/api/Meteorology/Agro/WaterBalanceSequential/Maps';

export default function useOptions() {
  const { data, isLoading, error } = useGetWBSequentialMapsOptionsQuery();

  useHandleRequestErrors(error as ResponseError);

  return {
    options: data,
    isLoading,
  };
}
